import { Logger } from '@nextgen-web-framework/core';
import logObject from './logObject';
import React from 'react';
import NotFound from 'components/NotFound/NotFound';
import { CMSTransformerDataType } from 'types/common';

const logger = Logger.getInstance(logObject('withNextgenRoute.tsx'));

export interface NotFoundPage {
  notFoundData: CMSTransformerDataType;
}

const withNextgenRoute = <T extends {}>(PageComponent: React.ComponentType<T>): React.FC<T & NotFoundPage> => {
  const NextgenRoute: React.FC<T & NotFoundPage> = (props) => {
    if (props.notFoundData) {
      return <NotFound data={props.notFoundData} showError={false} />;
    }
    return <PageComponent {...props} />;
  };

  return NextgenRoute;
};

export default withNextgenRoute;
